"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireDefault(require("react"));
var _DateType = _interopRequireDefault(require("./DateType"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/OutputTable/Search/TypeDate.js";
var keys = ['Daily', 'Weekly', 'Monthly', 'Custom'];
function TypeDate(_ref) {
  var _this = this;
  var field = _ref.field,
    onChange = _ref.onChange;
  var _React$useState = _react["default"].useState(keys[0]),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    key = _React$useState2[0],
    setKey = _React$useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("select", {
    onChange: function onChange(e) {
      return setKey(e.target.value);
    },
    className: "form-select shadow-none fs-xs w-auto rounded-0",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 13
    }
  }, keys.map(function (key) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: key,
      value: key,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 18,
        columnNumber: 33
      }
    }, key);
  })), /*#__PURE__*/_react["default"].createElement(_DateType["default"], {
    field: field,
    type: key,
    onChange: onChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 13
    }
  }));
}
var _default = TypeDate;
exports["default"] = _default;